var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "board-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "board-search"
  }, [_c('div', {
    staticClass: "board-search__box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filter.searchValue,
      expression: "filter.searchValue"
    }],
    staticClass: "board-search__input",
    attrs: {
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": _vm.filter.searchValue
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "searchValue", $event.target.value);
      }
    }
  }), _c('button', {
    staticClass: "board-search__button",
    attrs: {
      "type": "submit",
      "name": "button"
    },
    on: {
      "click": _vm.search
    }
  })]), _c('div', {
    staticClass: "board-search__select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filter.type,
      expression: "filter.type"
    }],
    staticClass: "board-search__selectbox",
    attrs: {
      "name": ""
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.filter, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("문의항목을 선택해주세요.")]), _vm._l(_vm.questionTypes, function (type, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": type
      }
    }, [_vm._v(_vm._s(type))]);
  })], 2)])]), _c('table', {
    staticClass: "board-list"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.questions, function (question, index) {
    return _c('tr', {
      key: question._id
    }, [_c('td', {
      staticClass: "board-list__txt board-list__txt--first",
      attrs: {
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s((_vm.page - 1) * _vm.limit + index + 1) + " ")]), _c('td', {
      staticClass: "board-list__tit",
      attrs: {
        "align": "center"
      },
      on: {
        "click": function click($event) {
          return _vm.details(question);
        }
      }
    }, [_c('div', {
      staticClass: "ellip"
    }, [_vm._v(_vm._s(question.subject))])]), _c('td', {
      staticClass: "board-list__txt",
      attrs: {
        "align": "center"
      }
    }, [question.reply ? _c('span', [_vm._v("답변완료")]) : _c('span', [_vm._v("미답변")])]), _c('td', {
      staticClass: "board-list__txt",
      attrs: {
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s(question.createdAt.toDate()) + " ")])]);
  }), 0)]), _c('pagination-component', {
    attrs: {
      "count": _vm.pageCount
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }), _c('div', {
    staticClass: "button-group justify-end"
  }, [_c('v-btn', {
    staticClass: "min-w-800px min-w-lg-100px",
    attrs: {
      "large": "",
      "rounded": "",
      "color": "primary",
      "elevation": "0"
    },
    on: {
      "click": _vm.write
    }
  }, [_c('span', [_vm._v("글쓰기")])])], 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', {
    staticClass: "d-none d-lg-table-header"
  }, [_c('tr', [_c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "8.5%"
    }
  }, [_vm._v("번호")]), _c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "66%"
    }
  }, [_vm._v("문의사항")]), _c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "17%"
    }
  }, [_vm._v("답변상태")]), _c('th', {
    staticClass: "board-list__txt",
    staticStyle: {
      "width": "8.5%"
    }
  }, [_vm._v("작성일")])])]);
}]

export { render, staticRenderFns }